import { call, put, takeLatest, select } from 'typed-redux-saga'
import {
	errorHandler,
	TaskModels,
	TasksNC,
	taskSlice,
	tasksSelectors,
	taskModelApi,
	loadersSlice,
} from 'Modules'
import { ResponseCatalog } from 'Models'
import { authSelector, authSlice } from 'Pages/auth'

function* updateTasks(res: TaskModels) {
	const orderTasks = yield* select(tasksSelectors.orderTasks)
	const changedOrderTask = orderTasks.entries.map((item: TaskModels) =>
		item.id === res.id ? res : item
	)
	yield* put(taskSlice.actions.setOrderTasks({ ...orderTasks, entries: changedOrderTask }))

	const tasks = yield* select(tasksSelectors.tasks)
	const changedTask = tasks.entries.map((item: TaskModels) => (item.id === res.id ? res : item))
	yield* put(taskSlice.actions.setTasks({ ...tasks, entries: changedTask }))

	const taskFromStats = yield* select(tasksSelectors.tasksFromStats)
	const changedTaskFromStats = taskFromStats.entries.map((item: TaskModels) =>
		item.id === res.id ? res : item
	)
	yield* put(taskSlice.actions.setTasksFromStats({ ...tasks, entries: changedTaskFromStats }))
}

function* getTasks(action: TasksNC.GetTasks) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { params, clear, order_ids, callback } = action.payload
		let oldItems = new ResponseCatalog<TaskModels>()
		if (!clear) {
			oldItems = yield* select(tasksSelectors.tasks)
		}
		const data = {
			...params,
			order_ids,
		}
		const res = yield* call(taskModelApi.getTasks, data)
		const items = new ResponseCatalog<TaskModels>(res)
		items.entries = [...oldItems.entries, ...res.entries]
		yield* put(taskSlice.actions.setParams(params))
		if (order_ids) {
			yield* put(taskSlice.actions.setOrderTasks(items))
		} else {
			yield* put(taskSlice.actions.setTasks(items))
			yield* put(taskSlice.actions.setCountAllTasks(res.total_entries))
		}
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* getTasksFromStats(action: TasksNC.GetTasksFromStats) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { params, clear, callback } = action.payload
		let oldItems = new ResponseCatalog<TaskModels>()
		if (!clear) {
			oldItems = yield* select(tasksSelectors.tasksFromStats)
		}
		const res = yield* call(taskModelApi.getTasks, { ...params, order_ids: [] })
		const items = new ResponseCatalog<TaskModels>(res)
		items.entries = [...oldItems.entries, ...res.entries]
		yield* put(taskSlice.actions.setParamsFromStats(params))
		yield* put(taskSlice.actions.setTasksFromStats(items))
		yield* put(taskSlice.actions.setCountAllTasksFromStats(res.total_entries))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* setCompletedStatusTask(action: TasksNC.setCompletedStatusTask) {
	try {
		const res = yield* call(taskModelApi.setCompletedStatusTask, action.payload)
		yield* call(updateTasks, res)
		yield* put(taskSlice.actions.getStatsTasks())
		const period = yield* select(tasksSelectors.period)
		yield* put(taskSlice.actions.getPeriodStats(period))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* setCreatedStatusTask(action: TasksNC.setCreatedStatusTask) {
	try {
		const res = yield* call(taskModelApi.setCreatedStatusTask, action.payload.toString())
		yield* call(updateTasks, res)
		yield* put(taskSlice.actions.getStatsTasks())
		const period = yield* select(tasksSelectors.period)
		yield* put(taskSlice.actions.getPeriodStats(period))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* getStatsTasks(action?: TasksNC.getStatsTasks) {
	try {
		const params = { period: action.payload }
		const res = yield* call(taskModelApi.getStatsTasks, params)
		yield* put(taskSlice.actions.setStatsTasks(res))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* showedTaskTraining(action?: TasksNC.showedTaskTraining) {
	try {
		yield* call(taskModelApi.showedTaskTraining)
		const user = yield* select(authSelector.getAuthDataSelector)
		yield* put(authSlice.actions.setUser({ ...user, task_model_training_showed: true }))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* clickedTaskModelLogo(action?: TasksNC.clickedTaskModelLogo) {
	try {
		yield* call(taskModelApi.clickedTaskModelLogo)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* getPeriodStats(action: TasksNC.getPeriodStats) {
	try {
		const params = { period: action.payload }
		const res = yield* call(taskModelApi.getStatsTasks, params)
		yield* put(taskSlice.actions.setPeriodStats(res))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* tasksSaga() {
	yield* takeLatest(taskSlice.actions.getTasks.type, getTasks)
	yield* takeLatest(taskSlice.actions.getTasksFromStats.type, getTasksFromStats)
	yield* takeLatest(taskSlice.actions.setCompletedStatusTask.type, setCompletedStatusTask)
	yield* takeLatest(taskSlice.actions.setCreatedStatusTask.type, setCreatedStatusTask)
	yield* takeLatest(taskSlice.actions.getStatsTasks.type, getStatsTasks)
	yield* takeLatest(taskSlice.actions.showedTaskTraining.type, showedTaskTraining)
	yield* takeLatest(taskSlice.actions.clickedTaskModelLogo.type, clickedTaskModelLogo)
	yield* takeLatest(taskSlice.actions.getPeriodStats.type, getPeriodStats)
}
